// extracted by mini-css-extract-plugin
module.exports = {"action":"_1obopwEt40Q3T2NCS2uzp_","dividerBlock":"_2BYBiCz3nbRUhgnvBwx91g","divider":"_1638fFk8JgmvmhOlSHBsqW"};